import React from 'react';
import { HtmlString } from '../../shared/types/HtmlString';
import { ComponentMessage } from '../../shared/enums/ComponentMessage';
import { Link } from 'react-router-dom';

interface Props {
  value: HtmlString;
}

const UserActivityUrlCell: React.FC<Props> = props => {
  return (
    <div>
      <Link to={`/google-analytics/userActivity/userId=${props.value}`}>
        {props.value ? props.value : ComponentMessage.NoDataShort}
      </Link>
    </div>
  );
};

export default UserActivityUrlCell;
